import React from 'react';
import './Stack.css';

const TAGS = [
  { label: 'Kubernetes', hi: true },
  { label: 'ArgoCD' },
  { label: 'Terraform', hi: true },
  { label: 'Helm' },
  { label: 'Prometheus', hi: true },
  { label: 'Grafana' },
  { label: 'EKS', hi: true },
  { label: 'GKE' },
  { label: 'Loki', hi: true },
  { label: 'Docker' },
  { label: 'AWS', hi: true },
  { label: 'Azure' },
  { label: 'GCP', hi: true },
  { label: 'Zscaler' },
  { label: 'Vertex AI', hi: true },
  { label: 'GitOps' },
  { label: 'Bitbucket', hi: true },
  { label: 'OpenSearch' },
  { label: 'WireGuard', hi: true },
  { label: 'Tempo' },
];

export default function Stack() {
  const doubled = [...TAGS, ...TAGS];
  return (
    <div className="stack">
      <div className="stack-label">// stack</div>
      <div className="stack-track">
        <div className="stack-scroll">
          {doubled.map((t, i) => (
            <span key={i} className={`stag ${t.hi ? 'on' : ''}`}>{t.label}</span>
          ))}
        </div>
      </div>
    </div>
  );
}
